import { IconButton, makeStyles } from '@material-ui/core';
import { MdClose } from 'react-icons/md';

const useStyles = makeStyles((theme: any) => ({
    modalContainer: {
        position: 'absolute',
        zIndex: 1,
        left: 0,
        top: 0,
        width: '100%',
        minHeight: '100%',
        backgroundColor: 'rgba(0,0,0,0.4)',
        marginBottom: 100,
        hidden: 'true',
    },
    modalContent: {
        background: '#F3F3F9',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        padding: 40,
        margin: 80,
        height: '100%',
        overflow: 'hidden',
    },
    title: {
        fontSize: 20,
        fontWeight: 700,
    },
    textField: {
        width: '80%',
        height: '100%'
    },
    titleContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
}));

interface Props {
    hidden: boolean;
    setHidden: React.Dispatch<React.SetStateAction<any>>;
}

export const TermsAndConditionsModal: React.FC<Props> = ({ hidden, setHidden }) => {
    const classes = useStyles();

    function handleChangeHidden(hidden: boolean) {
        setHidden(hidden);
    }

    return (
        <div className={classes.modalContainer} hidden={hidden}>
            <div className={classes.modalContent}>
                <div>
                    <div className={classes.titleContainer}>
                        <div className={classes.title}>
                            Terms & Conditions
                        </div>
                        <IconButton onClick={() => { handleChangeHidden(!hidden) }}>
                            <MdClose />
                        </IconButton>
                    </div>
                </div>
                <div>
                    <div>
                        <h3>Forretningsvilkår - frokost bestilling app - 3. sep. 2020</h3>
                        <h3>Priser</h3>
                        <p>Alle priser er eks. moms</p>
                        <p>Bookingsystemet er indrettet således at prisen pr. måltid stiger jo tættere på spisetidspunktet man som kunde booker.</p>
                        <p>Prisen kan af sælger løbende reguleres, den gældende pris vil altid fremgå når du booker.</p>

                        <ul >
                            <li>Mere end 72 timer før måltid – 50 kr.</li>
                            <li>Mere end 24 timer og mindre end 72 timer før måltid – 55 kr.</li>
                            <li>Mere end 1 time og mindre end 24 timer før måltid – 60 kr.</li>
                            <li>Mindre end 1. time før måltidet – 65 kr. - du kan ikke booke via appen mindre end en time før måltidet, men skal gå i front desk for at høre om det er flere pladser/måltider og booke der. </li>
                        </ul><br/>

                        <h3 ng-style="{'font-weight':'bold'}">Ændringer og annullering</h3>
                        <p>Du kan kun annullere eller ændre en booking mere end 24 timer før måltid.</p><br/>

                        <h3 ng-style="{'font-weight':'bold'}">Fakturering</h3>
                        <p>Måltiderne vil blive faktureret på månedlig basis ud fra de oplysninger du har givet os ved tilmeldingen til vores frokost bestilling.</p><br/>

                        <h3 ng-style="{'font-weight':'bold'}">Takeaway</h3>
                        <p>Når frokosten ikke spises i Republikkens kantine, vælges Takeaway muligheden. </p><br/>
                    </div>
                    <div>
                        <h2>Business terms - lunch ordering app - 3. sep. 2020</h2>
                        <h3>Prices</h3>
                        <p>Alle priser er eks. moms</p>
                        <p>Bookingsystemet er indrettet således at prisen pr. måltid stiger jo tættere på spisetidspunktet man som kunde booker.</p>
                        <p>Prisen kan af sælger løbende reguleres, den gældende pris vil altid fremgå når du booker.</p>

                        <ul >
                            <li>More than 72 hours before meal - DKK 50.</li>
                            <li>More than 24 hours before meal and less than 72 hours- DKK 55.</li>
                            <li>More than 1 hour before meal and less than 24 hours- DKK 60.</li>
                            <li>Less than 1 hour before the meal - DKK 65 - you can not book through the app less than an hour before the meal, but must go to the front desk to hear if there are more seats / meals and book there. </li>
                        </ul><br/>

                        <h3 ng-style="{'font-weight':'bold'}">Changes and cancellations</h3>
                        <p>You can only cancel or change a booking more than 24 hours before the meal.</p><br/>

                        <h3 ng-style="{'font-weight':'bold'}">Invoicing</h3>
                        <p>The meals will be invoiced on a monthly basis based on the information you have given us when registering for our lunch order.</p><br/>

                        <h3 ng-style="{'font-weight':'bold'}">Takeaway</h3>
                        <p>If you do not wish to eat lunch in Republikkens canteen, you should choose the Takeaway option.</p>
                        <p>For any questions or feedback please write to info@republikken.net</p><br/>
                    </div>
                </div>
            </div>
        </div>
    );
}
